import * as React from 'react';
import * as _ from 'lodash';
import SearchBar from '../../SearchBar';
import * as helpers from '../../../utilities/helpers';
import { cleanProps } from '../../../utilities/props';
import { GlobalHeaderButtons } from '../../PageLayout/GlobalHeaderButtons';
export default function (props, context) {
    function onChange1(e) {
        props.setSearchTerm(e.target.value);
    }
    return React.createElement('div', _.assign({}, cleanProps(props)), React.createElement(GlobalHeaderButtons, {}), React.createElement('div', { 'className': 'lightbox-header-container' }, React.createElement('div', { 'className': 'lightbox-title-block' }, React.createElement('h1', { 'id': 'PageTitle' }, props.activeInstallationGroup && props.activeInstallationGroup.customDisplayName || props.group), React.createElement('p', {}, props.activeInstallationGroup && props.activeInstallationGroup.customDescription || helpers.getFeatureGroupDescription(props.group)))), React.createElement(SearchBar, {
        'value': props.term,
        'onChange': onChange1.bind(this)
    }));
}